import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../../formInputsV2/styles/tokens';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const Title = styled.h4`
  margin: 0;
  font-family: ${v2FontFamily};
  font-size: 19px;
  font-weight: 700;
  color: ${v2Colors.text};

  b {
    color: ${v2Colors.primary};
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    font-size: 15px;
  }
`;

export const ModificaButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 8px 14px;
  border: 1.5px solid ${v2Colors.border};
  border-radius: 10px;
  background: #fff;
  font-family: ${v2FontFamily};
  font-size: 13px;
  font-weight: 600;
  color: ${v2Colors.text};
  cursor: pointer;
  transition: border-color 150ms ease, background-color 150ms ease;

  img {
    width: 12px;
    height: 12px;
  }

  &:hover,
  &:focus-visible {
    border-color: ${v2Colors.borderStrong};
    background: ${v2Colors.surface};
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 6px 10px;
    font-size: 12px;
  }
`;

// Mobile-only compact line shown even while the details panel is collapsed
// (e.g. "Panda · AB123CD"), so the card is still informative at a glance.
export const CompactSummary = styled.p`
  display: none;
  margin: 8px 0 0;
  font-family: ${v2FontFamily};
  font-size: 13.5px;
  font-weight: 400;
  color: ${v2Colors.text};

  @media (max-width: ${v2Breakpoints.tablet}) {
    display: block;
  }
`;

export const InfoList = styled.dl`
  margin: 16px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    margin-top: 10px;
    gap: 8px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;

  dt {
    margin: 0;
    font-family: ${v2FontFamily};
    font-size: 14px;
    font-weight: 600;
    color: ${v2Colors.textMuted};
  }

  dd {
    margin: 0;
    font-family: ${v2FontFamily};
    font-size: 14px;
    font-weight: 500;
    color: ${v2Colors.text};
    text-align: right;
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    dt,
    dd {
      font-size: 13px;
    }
  }
`;
